import { getNativeSessionToken } from './capacitor-session';
import { isNativePlatform } from './is-native';

/** Authorization header for native REST calls (empty on web). */
export async function getNativeBearerAuthHeaders(): Promise<Record<string, string>> {
  if (!isNativePlatform()) {
    return {};
  }
  const token = await getNativeSessionToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
